<template>
  <div class="content-view">
    <div class="boss-header"></div>
    <div class="list-view">
      <van-collapse ref="collapses" v-model="activeNames" icon="arrow" accordion change="change" class="collapse">
        <van-collapse-item v-for="(item, index) in dateList" :key="index" :name="index">
          <template #title>
            <div class="faq-list">
              <img class="faq-q" src="../../../assets/images/boss-home/faq-q.png" alt="" />
              <div class="faq-list">{{ item && item.title }}</div>
            </div>
          </template>
          <div v-html="item.content"></div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="bottom-list">
      <div class="bottom-button" @click="path">意见反馈</div>
    </div>
    <returnBack></returnBack>
  </div>
</template>

<script>
import returnBack from '@/views/person/components/returnBack.vue'
export default {
  name: 'questionList',
  components: {
    returnBack
  },
  data() {
    return {
      dateList: [
        {
          title: '1.“iEP”登录方式',
          content:
            '<p class="hasChild"><span class="number">a.</span><span class="con">未注册：通过公众号搜索“iEP电生理”或“iEP充电站”→关注“iEP电生理”或“iEP充电站”→点击“iEP微站”菜单→注册</span></p><p class="hasChild"><span class="number"><p class="hasChild"><span class="number">b.</span><span class="con">已注册：打开“iEP电生理”或“iEP充电站”→点击“iEP微站”→进入首页</span></p>'
        },
        {
          title: '2.iEP的学习模式是什么',
          content: '<p>iEP平台针对不同疾病所需掌握的技能，邀请国内外资深的专家进行了系统的讲解，有文献解读、病例交流、课程学习三大专区，可反复观看学习。不定期会推出直播活动，邀请国内外资深专家进行学术直播。</p>'
        },
        {
          title: '3.课程视频的完成条件是什么？',
          content: '<p>课程可以无限制进行观看，支持倍速播放，第一次观看时不支持拖拽进度。观看视频内容的80%，即算完成，视频右侧会呈现完成标识。</p>'
        },
        {
          title: '4.观看课程途中退出，学习进度会记录吗？',
          content: '<p>如果您时间有限未能够一次性学习完毕，不用担心，系统会记录您的观看进度，下一次进入会继续播放。</p>'
        }
      ],
      activeNames: [0]
    }
  },
  methods: {
    test() {
      let collapses = this.$refs.collapses
      collapses.$children[0].toggle(true)
      // collapses.$children[1].toggle(false)
      // collapses.$children[2].toggle(false)
      // collapses.$children[3].toggle(false)
      console.log('🚀 ~ file: questionList.vue:54 ~ test ~ collapses:', collapses)
    },
    path() {
      this.$router.push({
        path: '/helpCenter/feedback'
      })
    }
  },
  mounted() {
    this.test()
  }
}
</script>

<style lang="less" scoped>
.content-view {
  width: 100%;
  min-height: 100vh;
  font-size: 13px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  .boss-header {
    position: relative;
    height: 191px;
    background: url('../../../assets/images/boss-home/faq.png') center top no-repeat;
    background-size: 100% auto;
    width: 375px;
  }
  .list-view {
    height: calc(100vh - 80px - 49px - 24px);
    margin: 12px 12px;
    position: absolute;
    top: 80px;
    width: 361px;
    .collapse {
      // border-radius: 5px;
      height: calc(100vh - 80px - 49px - 24px);
      overflow: auto;
      padding-right: 10px;
    }
    .faq-list {
      align-items: center;
      display: flex;
      img {
        // display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      div {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
    }
    /deep/ .van-collapse-item__title--expanded .van-cell__right-icon::before {
      color: #EB1700;
    }
    /deep/ .van-collapse-item {
      box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04) !important;
      margin-bottom: 15px;
    }
    /deep/ .van-collapse-item__title {
      min-height: 49px;
      border-radius: 5px;
    }
    /deep/ .van-collapse-item__content {
      font-size: 13px;
      font-weight: 500;
      color: #333333;
      font-family: Source Han Sans CN, Source Han Sans CN;
      padding: 16px;
      p {
        line-height: 28px;
      }
      .hasChild {
        display: flex;
        .number {
          margin-right: 10px;
        }
        .con {
          flex: 1;
        }
      }
    }
    /deep/ .van-cell__title, .van-cell__value {
      display: flex;
    }
    /deep/ .van-hairline--top-bottom::after {
      border-width: 0px;
    }
    /deep/ .van-collapse-item--border::after {
      border-width: 0px;
    }
  }
  .bottom-list {
    text-align: center;
    width: 375px;
    height: 49px;
    box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.04);
    background: #ffffff;
    position: fixed;
    bottom: 0;
    .bottom-button {
      text-align: center;
      width: 351px;
      height: 35px;
      line-height: 35px;
      background: #EB1700;
      border-radius: 18px;
      margin: 7px 12px;
      color: #ffffff;
      font-size: 15px;
      font-weight: 500;
    }
  }
}
/deep/ .content-text {
  span {
    color: blue;
    border-bottom: 1px solid blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/helpCenter/views/questionList.vue